import {
    Component, Mixins, Watch, Emit,
} from 'vue-property-decorator';
import get from 'lodash.get';
import { v4 as uuid } from 'uuid';
import { toPascalCase, snakeToCamel } from '@components/shared/utils/string';
import * as Components from '@components/index';
import Props from './props';

/**
 * @name Form
 */
@Component({
    components: {
        ...Components,
    },
})
class YForm extends Mixins(Props) {
    model: object = {};
    keyHelper: string = uuid();
    inputTypes = ['text', 'search', 'email', 'url', 'hidden', 'password', 'number'];

    /**
     * Component Type
     * 
     * INFO: This condition is because, in the backend, we have `text` and `number`
     * component, which were created in the Groot v1.0,
     * And these components are deprecated in the Components.
     * By this way, we map these two components to the `input` component
     * which are created instead of `text` and `number`
     * 
     * Maybe, there need to pass type to the component, too.
     * It should be tested in the real project like panel.
     * 
     * @param {string} name 
     * @returns {string}
     */
    portName(name: string): string {
        let n: string = 'input';
        if (this.inputTypes.includes(name)) {
            n = 'input';
        } else if (name === 'date') {
            n = 'date_picker';
        } else {
            n = name;
        }

        return n;
    }

    /**
     * Return theme component
     *
     * @param {string} name
     * @returns {string}
     */
    componentName(name: string): string {
        return `y-${this.portName(name).replace(/_/, '-')}`;
    }

    /**
     * Return the Unique ID for the component
     * 
     * @param {string} id
     * @returns {string}
     */
    componentId(id: string): string {
        return `element-${this.keyHelper}-${id}`;
    }

    /**
     * Format params to camelCase
     *
     * @param {object} params
     * @param {string} component
     * @returns {object}
     */
    formatParams(params: object, component: string = ''): object {
        const baseProps = Object.keys(get(Components, `Y${toPascalCase(component)}.props`, {}));
        const mixins = get(Components, `Y${toPascalCase(component)}.mixins`, []);
        const props = mixins.reduce((acc, mixin) => {
            // eslint-disable-next-line no-param-reassign
            acc = acc.concat(Object.keys(mixin.props || {}));
            return acc;
        }, baseProps);

        return Object.entries(params).reduce((acc, [key, value]) => {
            if (!component || props.includes(snakeToCamel(key))) {
                acc[key.replace(/_/g, '-')] = value;
            }
            return acc;
        }, { component });
    }

    /**
     * Set Element Value to model
     * TODO: Uncomment if there is problem
     *
     * @param {*} val
     */
    // @Watch('value', { immediate: true, deep: true })
    // onValueChanged(val: any): any {
    //     if (val) {
    //         this.model = val;
    //     }
    // }

    /**
     * Emit model when Changed
     * 
     * @returns {object}
     */
    @Watch('model', { immediate: true, deep: true })
    @Emit('input')
    onModelChanged(): object {
        return this.model;
    }
}

export default YForm;
